<template>
  <tk-container class="project" :status="status" @refresh="initData">
    <tkui-header center slot="header">
      <tk-icon @click.native="back" slot="left-menu">Return</tk-icon>
      {{dealer.username || ''}}
    </tkui-header>
    <div class="body">
      <tk-flex v-if="projects.length" class="items" @click.native="toDetail(item)" v-for="(item, index) in projects" :key="item.objectId">
        <div class="leftBar full-height unshrink"></div>
        <div class="app-content">
          <h2 class="itemName">{{item.username}}</h2>
          <p class="des">经销商：{{dealer.dealerName || dealer.username || ''}}</p>
          <tk-flex top>
            <div class="location unshrink">
              <tk-icon style="width: 15px;color: #FB7B85;">location</tk-icon>
            </div>
            <span class="address fill">地址描述：{{item.projectAddress}}</span>
          </tk-flex>
        </div>
      </tk-flex>
      <tk-flex v-if="machines.length" v-for="(item, index) in machines" :key="item.objectId" class="items" @click.native="toMachine(item)">
        <div class="leftBar full-height unshrink" :style="{'background': color2}"></div>
        <div class="app-content">
          <h2 class="itemName">{{item.name}}</h2>
          <p class="des">型号：{{item.type}}</p>
          <tk-flex top>
            <div class="location unshrink">
              <tk-icon style="width: 15px;" :style="{'color':color2}">location</tk-icon>
            </div>
            <span class="address fill">地址描述：{{item.address}}</span>
          </tk-flex>
        </div>
      </tk-flex>
    </div>
  </tk-container>
</template>

<script>
  export default {
    data () {
      return {
        status: false,
        color2: '#0091FF',
        projects: [],
        machines: []
      }
    },
    computed: {
      dealer () {
        return this.$store.state.dealer || {}
      },
      isData () {
        return !this.projects.length && !this.machines.length ? 'empty' : false
      }
    },
    created () {
      this.initData()
    },
    methods: {
      back () {
        this.$back()
      },
      async initData () {
        this.status = 'loading'
        try {
          let projects = await this.$tkParse.getList('/users', {
            params: {
              where: {
                belong: this.dealer.objectId
              },
              'limit': 2000
            }
          })
          this.projects = projects
          let machine = await this.$tkParse.getList('/classes/machine', {
            params: {
              where: {
                'client': {
                  '$exists': false
                },
                dealer: this.dealer.objectId
              },
              'limit': 2000
            }
          })
          this.machines = machine
          this.status = this.isData
        } catch (e) {
          this.status = 'error'
          this.$tkGlobal.toast.add('获取数据失败')
        }
      },
      toDetail (project) {
        this.$store.commit('setProject', project)
        this.$push('/machines')
      },
      toMachine (machine) {
        this.$store.commit('setMachine', machine)
        this.$push('/detail')
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .project{
    .body{
      padding: 15px;
      .items{
        width: 100%;
        height: 110px;
        background: #ffffff;
        border-radius: 10px;
        overflow: hidden;
        margin-bottom: 10px;
        .leftBar{
          width: 25px;
          border-radius: 50%;
          margin-left: -15px;
          background: #FB7B85;
        }
        .app-content{
          padding: 15px;
          .itemName{
            font-size: 18px;
            color: #233038;
          }
          .des,.address{
            font-size: 14px;
            color: #999999;
            line-height: 24px;
            margin-bottom: 0 !important;
          }
          .location{
            width: 20px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/app/project/project.vue